import {Directive, OnDestroy} from '@angular/core';
import {guid} from '@datorama/akita';
import {UiService} from './state/ui.service';
import {UiQuery} from './state/ui.query';
import {Subscription} from 'rxjs';

@Directive({
  selector: '[imsBtnLoading]'
})
export class BtnLoadingDirective implements OnDestroy {

  private guid = guid();
  private subscription: Subscription;

  constructor(private ui: UiService, private qry: UiQuery) {
    this.subscription = this.qry.select(s => s.loadingBtn).subscribe(id => {
      if (!id) {
        console.log('no one is loading');
        return;
      }
      if (id !== this.guid) {
        console.log('someone is loading');
      }
      console.log('i am loading');
    });
  }

  onLoadEnd() {

  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
